import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import Checkbox from "@mui/material/Checkbox"; //Changed by Arun for Checkbox
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import DisabledImage from "../../../../src/Resources/Images/disable.png";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Input from "@mui/material/Input";
import InputAdornment from "@mui/material/InputAdornment";
import { visuallyHidden } from "@mui/utils";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import ConfirmBox from "../../../UiComponents/ConfirmBox/ConfirmBox";
import FloatLabel from "../../../UiComponents/FloatLabel/FloatLabel";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import { Transition } from "../../../UiComponents/Transition/Transition";
import DeleteImage from "../../../../src/Resources/Images/delete_common.png";
import {
  SearchIcon,
  EditIcon,
  DownloadIcon,
  CloudOffIcon,
  DeleteIcon,
  NotInterestedIcon,
  AddIcon,
} from "../../../Resources/Icons/icons";
import moment from "moment";
import AddCommonConfig from "./AddCommonConfig";
import { joinArrayValue } from "../../../Shared/formatArrayValue";
import {
  ROWS_PER_PAGE_WITH_ALL,
  rowMatchesSearch,
} from "../../../Shared/tableSearch";
import {
  ACTIVATE_CONFIRM,
  DISABLE_CONFIRM,
  UPDATE_DISABLE_DATE_CONFIRM,
} from "../../../Shared/configDisableConfirm";
import {
  GetUser,
  GetCompany,
  GetBookingCode,
  GetPolicyFindbyId,
  GetUserConfigByUserId,
  DisableUserConfig,
  GetUserConfigById,
  DeleteUserConfig,
} from "../../../Service/_index";
import Loader from "../../../UiComponents/Loader/Loader";
import { DatePicker } from "antd";
import { CSVLink } from "react-csv";
import {
  deleteCommonConfigById,
  deleteMultipleCommonConfigById,
  DeleteMultipleUserConfigById,
  disableCommonConfigById,
  disableMultipleCommonConfigById,
  disableMultipleUserConfigById,
  getCommonConfigById,
  getCommonConfigByUserId,
  updateCommonConfigDisableDate,
} from "../../../Service/UserConfigService";
import { ToastError } from "../../../UiComponents/Toaster/Toast";
import FilterBox from "../../../UiComponents/FilterBox/FilterBox";
import MasterCommonTable from "../../../UiComponents/CommonTable/MasterCommonTable";
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined";
import FilterListIcon from "@mui/icons-material/FilterList";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import EditCalendarOutlinedIcon from "@mui/icons-material/EditCalendarOutlined";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import ViewColumnOutlinedIcon from "@mui/icons-material/ViewColumnOutlined";
import TabFilter from "../../Tabs/Tabs";
import { Divider, Stack, Badge } from "@mui/material";

function stableSort(array, comparator) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis?.map((el) => el[0]);
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const headCells = [
  // {
  //   id: "code",
  //   placeMent: true,
  //   disablePadding: false,
  //   label: "Code",
  //   // the code is text (USR-12): sort on its number so USR-9 comes before USR-100
  //   sortBy: "codeNo",
  // },
  {
    id: "user",
    placeMent: true,
    disablePadding: false,
    label: "User",
  },
  {
    id: "company",
    placeMent: true,
    disablePadding: false,
    label: "Company Name",
  },
  {
    id: "bookingCode",
    placeMent: true,
    disablePadding: false,
    label: "Booking Code - Sub Booking Code",
  },
  {
    id: "product",
    placeMent: true,
    disablePadding: false,
    label: "Product - Sub Product",
  },
  {
    id: "policyType",
    placeMent: true,
    disablePadding: false,
    label: "Policy Type",
  },
  {
    id: "CC",
    placeMent: true,
    disablePadding: false,
    label: "CC / GVW",
  },
  {
    id: "location",
    placeMent: true,
    disablePadding: false,
    label: "RTO Code",
  },
  {
    id: "PACover",
    placeMent: true,
    disablePadding: false,
    label: "PA Cover",
  },
  {
    id: "UserConfig",
    placeMent: true,
    disablePadding: false,
    label: "User Config %",
  },
  {
    id: "BranchConfig",
    placeMent: true,
    disablePadding: false,
    label: "Branch Config %",
  },
  {
    id: "ReceivableConfig",
    placeMent: true,
    disablePadding: false,
    label: "Receivable Config %",
  },
  {
    id: "ActiveDate",
    placeMent: true,
    disablePadding: false,
    label: "Active Date",
  },
  {
    id: "DisableDate",
    placeMent: true,
    disablePadding: false,
    label: "Disable Date",
  },
];

// Array values (multi select columns) are shown as comma separated text
const formatArrayColumns = (row) => {
  const formattedRow = { ...row };
  headCells.forEach(({ id }) => {
    formattedRow[id] = joinArrayValue(formattedRow[id]);
  });
  return formattedRow;
};

const formatConfigPercentage = (config) =>
  Object.entries(config || {})
    .map(([key, value]) => `${key}:${value}`)
    .join(", ");

// One table row; the disable date is only shown on the In Active tab
const formatConfigRow = (row, requestType) => ({
  ...formatArrayColumns(row),
  ActiveDate: moment(row?.activeDate).format("DD/MM/YYYY"),
  ...(requestType === "DISABLED" && {
    DisableDate: row?.disableDate
      ? moment(row.disableDate).format("DD/MM/YYYY")
      : "",
  }),
  UserConfig: formatConfigPercentage(row?.userConfig),
  BranchConfig: formatConfigPercentage(row?.branchConfig),
  ReceivableConfig: formatConfigPercentage(row?.receivableConfig),
});

// User and Company can be saved as "ALL", so they can be filtered by it too
const allOption = { _id: "ALL", label: "ALL", value: "ALL" };

// Filters last applied with the Search button
const noFilters = { userId: null, companyId: null, bookingCodeId: null };

// The search box matches every column shown in the table
const searchColumns = [
  ...headCells.map(({ id }) => id),
  "subBookingCode",
  "subProduct",
  "GVW",
];

const FilterOption = [
  {
    label: "ActiveData",
    isEnabled: "true",
    value: 1,
  },
  {
    label: "In ActiveData",
    isEnabled: "false",
    value: 2,
  },
];

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells?.map((headCell) => (
          <TableCell
            className="TableHeader"
            key={headCell.id}
            align={headCell.placeMent ? "left" : "center"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{ fontSize: "16px", fontWeight: 600 }}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
};

const CommonConfig = () => {
  const todayDate = new Date();
  const LastWeekDate = new Date();
  LastWeekDate.setDate(LastWeekDate.getDate() - 7);
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("id");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [selectedData, setSelectedData] = React.useState({});
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [policyList, setPolicyList] = React.useState([]);
  const [companyDetails, setCompanyDetails] = useState([]);
  const [bookingCodeDetails, setBookingCodeDetails] = useState([]);
  const [openLoader, setOpenLoader] = useState(false);
  const [formType, setFormType] = useState("");
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedBookingCode, setSelectedBookingCode] = useState(null);
  const [openDeleteConfirmBox, setOpenDeleteConfirmBox] = React.useState(false);
  const [openMultipleDeleteConfirmBox, setOpenMultipleDeleteConfirmBox] =
    React.useState(false); // Changed by Arun
  const [openConfirmBox, setOpenConfirmBox] = React.useState(false);
  const [userDetails, setUserDetails] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [disabledDate, setDisabledDate] = useState("React-disable");
  const [confirmBoxConfig, setConfirmBoxConfig] = useState(DISABLE_CONFIRM);
  // What the confirm popup does: "disable" | "activate" | "updateDate" for the
  // ticked rows, or "row" for the switch of a single row
  const [confirmAction, setConfirmAction] = useState("disable");
  const [confirmInitialDate, setConfirmInitialDate] = useState(null);
  // Bumped after a bulk action so the table drops its ticked rows
  const [selectionVersion, setSelectionVersion] = useState(0);
  const [checkedRows, setCheckedRows] = useState([]); //Changed by Arun for Checkbox
  const [checkboxRows, setCheckboxRows] = useState({}); //Changed by Arun for Checkbox
  const [filter, setFilter] = useState({
    fn: (items) => {
      return items;
    },
  });

  const [selectedTab, setSelectedTab] = useState(1);
  const reqType = selectedTab === 2 ? "DISABLED" : "ACTIVE";
  const [appliedFilters, setAppliedFilters] = useState(noFilters);
  const latestRequestRef = useRef(0);
  const [showFilter, setShowFilter] = useState(false);
  const [selectedItems, setSelectedItems] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [tableConfig, setTableConfig] = useState({
    isAction: true,
    // isView: true,
    isEdit: true,
    isDelete: true,
    isSearch: true,
    isSwitch: true,
    isMultiDelete: true,
    wrapCells: true, // long text is folded into up to 3 lines
    selectAll: true, // the header checkbox ticks every row (this app's table keeps it off unless asked)
    type: "userConfiguration",
  });

  // Every word typed must be found in some column of the row. Memoized because
  // the table clears its ticked rows whenever the rows it shows change.
  const FilteredData = React.useMemo(
    () =>
      policyList.filter((el) =>
        rowMatchesSearch(el, searchColumns, searchText),
      ),
    [policyList, searchText],
  );

  // The list reloads from the effect below whenever the tab changes
  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const visibleRows = React.useMemo(
    () =>
      stableSort(filter.fn(policyList), getComparator(order, orderBy))?.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage,
      ),
    [order, orderBy, page, rowsPerPage, filter, policyList],
  );

  //Changed by Arun for Checkbox
  const checked = (checked, id, index) => {
    setCheckboxRows((prev) => ({ ...prev, [index]: checked }));
    checked
      ? checkedRows.push(id)
      : checkedRows.splice(checkedRows.indexOf(id), 1);
    console.log("checked rows ", checkedRows);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - policyList.length) : 0;

  const EditCommonConfig = (row) => {
    // The service resolves undefined when the request fails
    getCommonConfigById(row._id).then((res) => {
      if (!res?.data) {
        ToastError("Unable to load the selected record");
        return;
      }
      setOpenDrawer(true);
      setFormType("edit");
      setSelectedData(res.data);
    });
  };

  const onSearch = (e) => {
    let target = e.target;
    setFilter({
      fn: (items) => {
        if (target.value == "") return items;
        else
          return items.filter((el) =>
            `${el?.user},${el?.company},${el.bookingCode},${
              el?.subBookingCode
            },${el?.product},${el?.subProduct},${el?.policyType},${el?.CC},${
              el?.GVW
            },${el?.location},${el?.PACover},
            ${moment(el?.disableDate).format("DD/MM/YYYY")},${moment(
              el?.activeDate,
            ).format("DD/MM/YYYY")}`
              .toLowerCase()
              .includes(target.value.toLowerCase()),
          );
      },
    });
    setPage(0);
  };

  const GetUserDetails = () => {
    const bodyData = {
      requesttype: "TABLE",
      isAscending: true,
    };
    GetUser(bodyData)
      .then((res) => {
        const modifiedUserDetails = res.data
          .map((e) => {
            if (e.userType.includes("user") && e.isEnabled) {
              // console.log(e);
              return {
                ...e,
                label: e?.name + " - " + e?.mobileNumber + " - " + e?.email,
                value: e._id,
              };
            }
          })
          .filter(Boolean);
        setUserDetails([allOption, ...modifiedUserDetails]);
        setOpenLoader(false);
      })
      .catch((err) => {
        setOpenLoader(false);
      });
  };

  const GetCompanyDetails = () => {
    GetCompany({ isAscending: true }).then((res) => {
      //isAscending added by gokul...
      const modifiedCompanyDetails = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.shortName,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      setCompanyDetails([allOption, ...modifiedCompanyDetails.sort()]);
    });
  };

  const GetBookingCodeDetails = () => {
    GetBookingCode({ isAscending: true }).then((res) => {
      const modifiedBookingCode = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.bookingCode,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      setBookingCodeDetails(modifiedBookingCode);
    });
  };

  const handleDateChange = (date) => {
    console.log("Selected date from child:", date);
    setDisabledDate(date); // receive date from child
  };

  React.useEffect(() => {
    GetCompanyDetails();
    GetBookingCodeDetails();
    GetUserDetails();
  }, []);

  const header = [
    // { label: "Code", key: "code" },
    { label: "User", key: "user" },
    { label: "Company Name", key: "company" },
    { label: "Booking Code", key: "bookingCode" },
    { label: "Sub Booking Code", key: "subBookingCode" },
    { label: "Product", key: "product" },
    { label: "Sub Product", key: "subProduct" },
    { label: "Policy Type", key: "policyType" },
    { label: "CC", key: "CC" },
    { label: "GVW", key: "GVW" },
    { label: "RTO Code", key: `location` },
    { label: "PA Cover", key: "PACover" },
    { label: "User Config%", key: "UserConfig" },
    { label: "Branch Config%", key: "BranchConfig" },
    { label: "Receivable Config%", key: "ReceivableConfig" },
    { label: "Active Date", key: "ActiveDate" },
    { label: "Disable Date", key: "DisableDate" },
  ];
  const csvFile = {
    filename: "User Payable Data",
    headers: header,
    data: FilteredData,
  };

  // Loads the list for the current tab and the filters applied with Search.
  // There is no sub booking code filter: configs are saved per booking code
  const fetchConfigs = () => {
    const requestId = ++latestRequestRef.current;
    const requestType = reqType;
    getCommonConfigByUserId(appliedFilters.userId || undefined, {
      requestType,
      companyId: appliedFilters.companyId || undefined,
      bookingCodeId: appliedFilters.bookingCodeId || undefined,
    }).then((res) => {
      // An older request that finishes late must not replace newer results
      if (requestId !== latestRequestRef.current) return;
      // The service resolves undefined when the request fails
      if (!res) ToastError("Unable to load the configurations");
      setPolicyList(
        (res?.data || []).map((row) => formatConfigRow(row, requestType)),
      );
    });
    setPage(0);
  };
  // Changed by Arun
  const DeleteMultipleUserConfigData = () => {
    if (checkedRows.length == 0) {
      ToastError("Please select record");
    } else {
      setOpenMultipleDeleteConfirmBox(true);
    }
  };
  // Changed by Arun
  const DeleteMultipleFunction = () => {
    deleteMultipleCommonConfigById(checkedRows).then((res) => {
      setCheckedRows([]);
      setCheckboxRows({});
      fetchConfigs();
      console.log("checked rows ", checkedRows);
      console.log("check box rows ", checkboxRows);
    });
    setOpenMultipleDeleteConfirmBox(false);
  };

  const DeleteCommonConfigData = (row) => {
    setOpenDeleteConfirmBox(true);
    setSelectedData(row);
  };
  const DeleteFunction = () => {
    deleteCommonConfigById(selectedData._id).then((res) => {
      fetchConfigs();
    });
    setOpenDeleteConfirmBox(false);
  };
  // Opens the shared confirm popup for one of the toolbar actions
  const openBulkConfirm = (action, config, initialDate = null) => {
    if (checkedRows.length === 0) {
      ToastError("Please select record");
      return;
    }
    setConfirmAction(action);
    setConfirmBoxConfig(config);
    setConfirmInitialDate(initialDate);
    setDisabledDate(config.mode === "picker" ? "React-disable" : null);
    setOpenConfirmBox(true);
  };

  const DisableMultipleUserConfigData = () =>
    openBulkConfirm("disable", DISABLE_CONFIRM);

  const ActivateMultipleUserConfigData = () =>
    openBulkConfirm("activate", ACTIVATE_CONFIRM);

  // With one ticked row the picker starts on its current disable date
  const UpdateDisableDateMultipleConfigData = () =>
    openBulkConfirm(
      "updateDate",
      UPDATE_DISABLE_DATE_CONFIRM,
      checkedRows.length === 1 ? checkedRows[0].disableDate : null,
    );

  // The switch on a single row
  const ActiveUserConfigData = (row) => {
    setSelectedData(row);
    setConfirmAction("row");
    setConfirmInitialDate(null);
    if (row.isEnabled) {
      setConfirmBoxConfig(DISABLE_CONFIRM);
      setDisabledDate("React-disable");
    } else {
      setConfirmBoxConfig(ACTIVATE_CONFIRM);
      setDisabledDate(null);
    }
    setOpenConfirmBox(true);
  };

  const DisableUserConfigFunction = (selectedDate) => {
    const ids = checkedRows.map((row) => row._id);
    let request;
    if (confirmAction === "row") {
      request = disableCommonConfigById(selectedData._id, {
        requesttype: selectedData.isEnabled ? "true" : "false",
        disableDate: selectedDate,
      });
    } else if (confirmAction === "updateDate") {
      request = updateCommonConfigDisableDate(ids, selectedDate);
    } else {
      request = disableMultipleCommonConfigById(ids, {
        requesttype: confirmAction === "activate" ? "false" : "true",
        disableDate: selectedDate,
      });
    }
    // The services resolve undefined when the server rejects the request, so
    // the ticks stay and the user can try again
    request.then((res) => {
      if (!res) return;
      setCheckedRows([]);
      setCheckboxRows({});
      setSelectionVersion((version) => version + 1);
      fetchConfigs();
      setOpenConfirmBox(false);
    });
  };

  // Picking a filter does not search; the list reloads on a tab change or
  // when Search / Clear All updates the applied filters
  useEffect(() => {
    fetchConfigs();
  }, [reqType, appliedFilters]);

  const handleMultiDelete = (items) => {
    console.log(items, "II");
    setCheckedRows(items);
  };

  // Clear All empties the filters and shows the full list again
  const handleClearAllState = () => {
    setSelectedUser(null);
    setSelectedCompany(null);
    setSelectedBookingCode(null);
    setAppliedFilters(noFilters);
  };

  // A single ✕ only clears that pick; the list changes on the next Search.
  // Passed to FilterBox so its ✕ does not run a search by itself
  const handleClearSingleFilter = (filterId) => {
    if (filterId === 1) {
      setSelectedUser(null);
    } else if (filterId === 2) {
      setSelectedCompany(null);
    } else if (filterId === 3) {
      setSelectedBookingCode(null);
    }
  };

  // Search applies the picked filters (a new object, so it always reloads)
  const handleSaveAllFilter = () => {
    setAppliedFilters({
      userId: selectedUser,
      companyId: selectedCompany,
      bookingCodeId: selectedBookingCode,
    });
  };
  const [dateRange, setDateRange] = useState([new Date(), new Date()]);

  const filterBoxData = [
    {
      id: 1,
      label: "Select User",
      data: userDetails,
      setState: setSelectedUser,
      value: selectedUser,
      type: "input",
      variation: "single",
    },
    {
      id: 2,
      label: "Select Company",
      data: companyDetails,
      setState: setSelectedCompany,
      value: selectedCompany,
      type: "input",
      variation: "single",
    },
    {
      id: 3,
      label: "Select BookinCode",
      data: bookingCodeDetails,
      setState: setSelectedBookingCode,
      value: selectedBookingCode,
      type: "input",
      variation: "single",
    },
  ];

  const activeFiltersCount = [
    selectedUser,
    selectedCompany,
    selectedBookingCode,
  ].filter(Boolean).length;

  return (
    <>
      <div>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Box sx={{ position: "relative", zIndex: 1, mt: 0 }}>
            <Grid container className="Master_Card_Container">
              <Grid
                container
                alignItems={"center"}
                className="Master_Card_Sub_Container"
                sx={{ mb: 2 }}
              >
                <Grid item xs={12} sm={6} md={4}>
                  <Typography className="Master_Card_Tittle">
                    Common Configuration
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={8}
                  className="d-flex"
                  justifyContent={{
                    xs: "start",
                    sm: "flex-end",
                    md: "flex-end",
                  }}
                >
                  <Stack
                    direction={{ xs: "column", sm: "row", md: "row" }}
                    spacing={2}
                    mt={{ xs: 2, sm: 2, md: 0 }}
                  >
                    <Stack direction="row" spacing={2} sx={{ width: "100%" }}>
                      <Button
                        className="Master_Card_Filter_Button w-100"
                        startIcon={
                          <DeleteIcon
                            sx={{
                              marginRight: "1.5px",
                            }}
                          />
                        }
                        onClick={() => DeleteMultipleUserConfigData()}
                      >
                        Delete
                      </Button>
                      {reqType === "DISABLED" ? (
                        <>
                          <Button
                            className="Master_Card_Filter_Button  w-100"
                            startIcon={
                              <CheckCircleOutlineIcon
                                sx={{ marginRight: "1.5px" }}
                              />
                            }
                            onClick={() => ActivateMultipleUserConfigData()}
                          >
                            Activate
                          </Button>
                          <Button
                            className="Master_Card_Filter_Button  w-100"
                            sx={{ whiteSpace: "nowrap" }}
                            startIcon={
                              <EditCalendarOutlinedIcon
                                sx={{ marginRight: "1.5px" }}
                              />
                            }
                            onClick={() =>
                              UpdateDisableDateMultipleConfigData()
                            }
                          >
                            Update Disable Date
                          </Button>
                        </>
                      ) : (
                        <Button
                          className="Master_Card_Filter_Button  w-100"
                          startIcon={
                            <NotInterestedIcon
                              sx={{
                                marginRight: "1.5px",
                              }}
                            />
                          }
                          onClick={() => DisableMultipleUserConfigData()}
                        >
                          Disable
                        </Button>
                      )}
                      <Button
                        className="Master_Card_Filter_Button w-100"
                        sx={{ width: "102px", height: "40px", gap: "8px" }}
                        startIcon={
                          <Badge
                            badgeContent={activeFiltersCount}
                            color="error"
                            sx={{
                              "& .MuiBadge-badge": {
                                right: 5,
                                top: 3,
                                width: "14px",
                                height: "14px",
                                minWidth: "14px",
                                borderRadius: "50%",
                                fontSize: "8.91px",
                                fontWeight: "600",
                                backgroundColor: "#E50000",
                                color: "#fff",
                                padding: 0,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              },
                            }}
                          >
                            <FilterListIcon sx={{ marginRight: "1.5px" }} />
                          </Badge>
                        }
                        onClick={() => setShowFilter(!showFilter)}
                      >
                        Filters
                      </Button>
                      <Button
                        className="Master_Card_Filter_Button w-100"
                        sx={{ width: "102px", height: "40px", gap: "8px" }}
                        startIcon={
                          <CloudDownloadOutlinedIcon
                            sx={{
                              color: "#344054",
                            }}
                          />
                        }
                      >
                        <CSVLink
                          style={{ textDecoration: "none", color: "inherit" }}
                          {...csvFile}
                        >
                          Export
                        </CSVLink>
                      </Button>
                      <Button
                        className="Master_Card_create_Button w-100"
                        startIcon={
                          <AddIcon
                            sx={{
                              marginRight: "1.5px",
                            }}
                          />
                        }
                        onClick={() => {
                          setOpenDrawer(true);
                          setFormType("add");
                          setSelectedData({});
                        }}
                      >
                        Create
                      </Button>
                      {/* <IconButton
                        sx={{
                          border: "1px solid #D0D5DD",
                          borderRadius: "8px",
                          padding: "8px",
                        }}
                      >
                        <ViewColumnOutlinedIcon />
                      </IconButton> */}
                    </Stack>
                  </Stack>
                </Grid>
              </Grid>

              {/* Filter Section */}
              {showFilter && (
                <Box
                  sx={{
                    mb: 2,
                    overflow: "visible",
                    position: "relative",
                    zIndex: 1200,
                    minHeight: "60px",
                    width: "100%",
                  }}
                >
                  <FilterBox
                    filterData={filterBoxData}
                    type={"single"}
                    handleClearAllState={handleClearAllState}
                    handleSaveAllFilter={handleSaveAllFilter}
                    handleClearSingleFilter={handleClearSingleFilter}
                    horizontalLayout={true}
                    hideHeader={true}
                    hideInput={true}
                    alwaysOpen={true}
                    autoApply={false}
                    searchOnPick={false}
                  />
                </Box>
              )}
              <Grid item xs={12}>
                <Divider
                  sx={{
                    backgroundColor: "#EAECF0",
                    borderWidth: 1,
                  }}
                />
              </Grid>
              <Grid
                container
                alignItems={"center"}
                justifyContent={"space-between"}
                className="Master_Card_Sub_Container"
              >
                {/* <Grid item xs={12} sm={8} md={8}></Grid> */}
                <TabFilter
                  options={FilterOption}
                  selectedTab={selectedTab}
                  onTabChange={handleTabChange}
                />
                <Grid item xs={12} sm={4} md={3.1} mt={{ xs: 2, sm: 0, md: 0 }}>
                  <Input
                    focused="false"
                    className="w-100 Master_Card_Input"
                    id="standard-adornment-password"
                    // onChange={onSearch}
                    onChange={(e) => {
                      setSearchText(e.target.value);
                      setPage(0);
                    }}
                    disableUnderline={true}
                    placeholder="Search"
                    startAdornment={
                      <InputAdornment
                        position="start"
                        sx={{ marginRight: "0px" }}
                      >
                        <IconButton aria-label="toggle password visibility">
                          <SearchIcon
                            sx={{
                              fontSize: "20px",
                            }}
                          />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </Grid>
              </Grid>
              <MasterCommonTable
                key={`${selectedTab}-${selectionVersion}`}
                tableConfig={tableConfig}
                data={FilteredData}
                columns={headCells}
                allData={FilteredData}
                rowsPerPageOptions={ROWS_PER_PAGE_WITH_ALL}
                // isServerSide={true}
                // handleOnClickBehaviour={OpenPolicyFile}
                handleEdit={EditCommonConfig}
                handleDelete={DeleteCommonConfigData}
                handleApprove={ActiveUserConfigData}
                handleMultiDelete={handleMultiDelete}
                // handleButton2={handleButton}
                tableTotalCount={FilteredData.length}
              />
            </Grid>
          </Box>
        </Box>
      </div>
      <Loader open={openLoader} />
      <Dialog
        open={openDrawer}
        TransitionComponent={Transition}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          sx: {
            maxWidth: {
              xs: "80%",
              sm: "70%",
              md: "50%",
              lg: "60%",
            },
          },
        }}
      >
        {openDrawer ? (
          <AddCommonConfig
            setOpenDrawer={setOpenDrawer}
            selectedUser={selectedUser}
            ActiveFunction={fetchConfigs}
            selectedData={selectedData}
            formType={formType}
          />
        ) : null}
      </Dialog>
      <ConfirmBox
        open={openDeleteConfirmBox}
        title="Delete"
        content="Are you sure you want to delete this?"
        subContent="This action cannot be undone. Once deleted, the data will be permanently removed from the system."
        img={DeleteImage}
        confirmButton="Delete"
        setOpenConfirmBox={setOpenDeleteConfirmBox}
        Function={DeleteFunction}
        icon={<DeleteIcon />}
        color="error"
      />
      <ConfirmBox
        open={openMultipleDeleteConfirmBox}
        title="Delete"
        content="Are you sure you want to delete this?"
        subContent="This action cannot be undone. Once deleted, the data will be permanently removed from the system."
        img={DeleteImage}
        confirmButton="Delete"
        setOpenConfirmBox={setOpenMultipleDeleteConfirmBox}
        Function={DeleteMultipleFunction}
        icon={<DeleteIcon />}
        color="error"
      />
      <ConfirmBox
        setDisabledDate={handleDateChange}
        disabledDate={disabledDate}
        initialDate={confirmInitialDate}
        mode={confirmBoxConfig.mode}
        open={openConfirmBox}
        title={confirmBoxConfig.title}
        content={
          confirmBoxConfig.mode === "picker" && disabledDate === "React-disable"
            ? "Please select the date ... !"
            : confirmBoxConfig.content
        }
        confirmButton={confirmBoxConfig.confirmButton}
        setOpenConfirmBox={setOpenConfirmBox}
        Function={DisableUserConfigFunction}
        icon={<NotInterestedIcon />}
        color="error"
        img={DisabledImage}
        subContent={confirmBoxConfig.subContent}
      />
    </>
  );
};
export default CommonConfig;
